<template>
  <div class="fold">
    <div class="logo"><img src="~assets/common/logo-default.png"/></div>
    <div class="wrapper">
      <el-collapse v-model="activeName" accordion>
        <el-collapse-item :title='$t("about.nav[0].title")' name="1">
          <ul>
            <li><router-link to="/about">{{$t("about.nav[0].title")}}</router-link></li>
          </ul>
        </el-collapse-item>
        <el-collapse-item :title='$t("about.nav[1].title")' name="2">
          <ul>
            <li><router-link to="/about/sign">{{$t("about.nav[1].item1")}}</router-link></li>
            <li><router-link to="/about/idea">{{$t("about.nav[1].item2")}}</router-link></li>
          </ul>
        </el-collapse-item>
        <el-collapse-item :title='$t("about.nav[2].title")' name="3">
          <ul>
            <li><router-link to="/about/history">{{$t("about.nav[2].title")}}</router-link></li>
          </ul>
        </el-collapse-item>
      </el-collapse>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Fold',
  data () {
    return {
      activeName: '1'
    }
  },
  mounted () {
    this.setFold()
  },
  computed: {
  },
  methods: {
    setFold () {
      let routePath = this.$route.path
      this.activeName = '1'
      if (routePath === '/about/idea' || routePath === '/about/sign') this.activeName = '2'
      else if (routePath === '/about/history') this.activeName = '3'
    }
  },
  watch: {
    $route: function (to, from) {
      this.setFold()
    }
  }
}
</script>

<style scoped lang="stylus">
  @import "~styles/varibles"
  @import "~styles/mixins"
  .fold
    width 18%
    height 500px
    background #FFF
    ul
      background #f9fafa
      text-indent 30px
    li
      cursor pointer
      line-height 28px
    li:hover
      background #eeeeee
    a
      display block
    .wrapper
      margin-top 39px
</style>



// WEBPACK FOOTER //
// src/pages/about/components/Fold.vue